import { Site } from './account/site.model';

/**
 * Model for API TimelineFocusItemReply Model
 */
export class FocusRange {
  /**
   * Contract ID (if applicable - only one field of each element will be present)
   */
  contractId: number;

  /**
   * Account ID (if applicable - only one field of each element will be present)
   */
  accountId: number;

  /**
   * Site (if applicable - only one field of each element will be present)
   */
  site: Site;

  constructor(attributes: Partial<FocusRange> = {}) {
    Object.assign(this, attributes);
  }
}
